export default __webpack_public_path__ + "static/media/img-12.5e4cbba3.jpg";